import React from 'react'
import {Grid, Row, Col} from 'react-bootstrap'
import CubeLink from '../User/Dashboard/CubeLink'
import {FiHelp} from '../Common/ReactIcons/icons'

class HelpScreen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      links: [
        {name: 'من مالک هستم', description: 'آموزش نحوه اعلام مالکیت یک اسب در سایت', path: '/page/help-im-an-owner', icon: <FiHelp />},
        {name: 'من پرورش دهنده هستم', description: 'آموزش نحوه اعلام اینکه پرورش دهنده یک اسب هستید', path: '/page/help-im-a-breeder', icon: <FiHelp />},
        {name: 'گزارش اشکال در اطلاعات اسب', description: 'آموزش گزارش اشکالات در اطلاعات یک اسب', path: '/page/help-horse-report', icon: <FiHelp />},
        {name: 'جستجو', description: 'آموزش نحوه جستجو یک اسب در سایت', path: '/page/help-search', icon: <FiHelp />},
        {name: 'قرار دادن عکس برای اسب', description: 'آموزش نحوه قرار دادن عکس یک اسب', path: '/page/help-image-upload', icon: <FiHelp />},
        {name: 'پیشنهاد تغییر در سایت', description: 'آموزش نحوه دادن پیشنهاد ایجاد یک ویژگی جدید در سایت یا تغییر یک بخش موجود', path: '/page/help-add-new-feature', icon: <FiHelp />}
      ]
    }
  }
  render () {
    const {links} = this.state
    return (
      <Grid>
        <Row>
          <Col sm={10} smOffset={1} xs={12} xsOffset={0}>
            <Row className="title">
              <Col xs={12}>
                <h2>راهنمای استفاده از سایت</h2>
                <p>راهنمای استفاده از بخش‌های مختلف آیاهو در اینجا قرار داده می‌شود.</p>
              </Col>
            </Row>
            <Row className="wrapper">
              <Col xs={12} className="context">
                {links.map((item, index) => <CubeLink key={index} target={item} />)}
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default HelpScreen



// WEBPACK FOOTER //
// ./src/components/Help/HelpScreen.js